export default __webpack_public_path__ + "static/media/signalfx.4297faf784995cd5a095508e6814c42a.svg";